import { mergeStyles } from '../../../../internal/utils/mergeStyles';
import mainStyles from './styles.module.css';
import { getDeviceStyles, getDeviceStylesIdentity } from './device';
import { memoizeWith } from 'ramda';
function getRadioGroupStyles(deviceType) {
  var deviceStyles = getDeviceStyles(deviceType);
  return mergeStyles(mainStyles, deviceStyles);
}
export var getStyles = memoizeWith(getDeviceStylesIdentity, getRadioGroupStyles);